import React from 'react';
import { Modal, ModalHeader, ModalBody, Badge } from 'reactstrap';

import DataTable from '../../components/Table/DataTable'

import utility from '../../services/utility';
import { OPERATION_TYPE } from '../../enums/operationType';
import { QUEUE_STATUS } from '../../enums/queueStatus';

const formatStatus = (status) => {
    const { background, name } = QUEUE_STATUS[status];
    return <Badge color={background}>{name}</Badge>;
}

const QueueItemHistoryModal = props => {
    const columns = ["mediaId", "creationDate", "operation", "status", "startDate", "finishDate", "retries", "details"];

    const options = {
        key: "id",
        column: {
            "mediaId": { header: "Media" },
            "creationDate": {
                header: "Creation Date",
                transform: utility.formatDateTimeString
            },
            "operation": {
                header: "Operation",
                transform: (value) => utility.mapValue(value, OPERATION_TYPE)
            },
            "status": {
                header: "Status",
                transform: (value) => formatStatus(value)
            },
            "finishDate": {
                header: "Finish Date",
                transform: utility.formatDateTimeString
            },
            "startDate": {
                header: "Start Date",
                transform: utility.formatDateTimeString
            },
            "retries": { header: "Retries" },
            "details": {
                header: "Details",
                classes: ["pre-wrap"],
                transform: utility.formatMultilineString
            }
        }
    };

    return (
        <Modal isOpen={props.isOpen} backdrop={true} toggle={props.toggle} scrollable size="xl">
            <ModalHeader toggle={props.toggle} tag="h3">
                {`${props.media.show}: ${props.media.mediaId}`}
            </ModalHeader>
            <ModalBody>
                <DataTable columns={columns} options={options} data={props.media.data} />
            </ModalBody>
        </Modal>
    );
}

export default QueueItemHistoryModal;